import { render, staticRenderFns } from "./r-button.vue?vue&type=template&id=7201ad1c&"
import script from "./r-button.vue?vue&type=script&lang=js&"
export * from "./r-button.vue?vue&type=script&lang=js&"
import style0 from "./r-button.vue?vue&type=style&index=0&id=7201ad1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports